import { siteInfo } from '@/mocks/site';

export default function CTASection() {
  return (
    <section className="relative w-full py-20 md:py-28 overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Warm%20vibrant%20social%20community%20gathering%20abstract%20background%2C%20orange%20coral%20and%20amber%20gradient%20waves%2C%20energetic%20atmosphere%2C%20dynamic%20flowing%20shapes%2C%20modern%20clean%20design%2C%20editorial%20photography%20style%2C%20warm%20inviting%20mood&width=1800&height=800&seq=cta-bg-warm&orientation=landscape"
          alt="加入吃瓜前线"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-black/75 via-black/50 to-black/75"></div>
      </div>

      <div className="relative z-10 w-full px-4 md:px-6">
        <div className="mx-auto max-w-2xl text-center">
          <h2 className="text-3xl md:text-5xl font-heading font-bold text-background-50 leading-tight">
            加入吃瓜前线
          </h2>
          <p className="mt-4 text-sm md:text-base text-background-300 leading-relaxed">
            QQ吃瓜群实时推送黑料
          </p>
          <p className="text-sm md:text-base text-background-300 leading-relaxed">
            每日更新热门大瓜，不再错过任何一个爆料
          </p>

          <a
            href={`https://qm.qq.com/q/${siteInfo.qqGroupNumber}`}
            target="_blank"
            rel="nofollow noopener noreferrer"
            className="inline-flex items-center gap-3 mt-8 px-8 py-4 bg-foreground-950 text-background-50 font-semibold rounded-full hover:bg-foreground-800 transition-all cursor-pointer group"
          >
            <span className="w-9 h-9 rounded-full bg-primary-500 flex items-center justify-center">
              <i className="ri-qq-line text-base text-background-50"></i>
            </span>
            <span className="text-base whitespace-nowrap">立即加群</span>
            <i className="ri-arrow-right-up-line text-lg transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5"></i>
          </a>
        </div>
      </div>
    </section>
  );
}